import React from "react";
import { useSearchParams } from "react-router-dom";

import type { FilterValue } from "@repo/shopify/types/generated/storefront.types";

import Input from "@atoms/Input";

interface IProps {
  filterList: FilterValue[];
  selected: string[];
  onChangeFilter: (option: FilterValue, key: string) => void;
  filterKey: string;
}

export default function FilterCard({ filterList, selected, onChangeFilter, filterKey }: IProps) {
  const [, setSearchParams] = useSearchParams();

  const options = filterList.filter((option) => option.count).map((item) => ({ ...item, text: item.label.replace("Archive_", "") }));

  return (
    <div className="flex flex-col gap-2.5 leading-none">
      <span className="capitalize">{filterKey}</span>
      <div className="pc:gap-1.5 flex flex-col gap-2">
        <Input
          checked={selected.length === 0}
          className="items-center!"
          id={`All ${filterKey}`}
          innerClassName="mt-0!"
          label={`All ${filterKey}`}
          labelClassName="capitalize"
          name={filterKey}
          onChange={() => {
            setSearchParams((prev) => {
              const next = new URLSearchParams(prev);
              next.delete(filterKey === "discount" ? "tag" : filterKey);
              return next;
            });
          }}
          type="checkbox"
          value={`All ${filterKey}`}
        />

        {options.length ? (
          <>
            {options.map((option) => (
              <Input
                checked={selected.includes(option.label)}
                className="items-center!"
                id={option.text}
                innerClassName="mt-0!"
                key={option.text}
                label={option.text}
                name={filterKey}
                onChange={() => {
                  onChangeFilter(option, filterKey === "discount" ? "tag" : filterKey);
                }}
                type="checkbox"
                value={option.text}
              />
            ))}
          </>
        ) : null}
      </div>
    </div>
  );
}
